module.exports = __webpack_public_path__ + "static/media/Icons_dark_star.e3d5357d.svg";